export default "__VITE_ASSET__tA_aQjNw__"